import { useMemo } from 'react';

import BonusLexer, { Token, TokenType } from '../lib/lexer';

export const useBonusTextTokens = (text: string, checkForAmount = true) =>
	useMemo(() => {
		const lexer = new BonusLexer(text, {
				checkForAmount,
				checkForEmoji: false,
			}),
			tokens: Token[] = [];

		let token = lexer.getToken();

		tokens.push(token);

		while (token && token.kind !== TokenType.EOF) {
			token = lexer.getToken();
			tokens.push(token);
		}

		return tokens;
	}, [checkForAmount, text]);
